/** Shared copy for Medication Administration Record (MAR) affordances. */

/** Shown when no visit is selected (recording requires a visit). */
export const MAR_NO_VISIT_REASON =
  'Select a visit (above) to record an administration.';

/**
 * Shown when the selected visit is signed/completed. Covers both adding new
 * records and editing/deleting existing ones — neither is allowed once a visit
 * is no longer editable (the server enforces the same rule).
 */
export const MAR_VISIT_NOT_EDITABLE_REASON =
  'This visit is signed or completed and can no longer be edited.';
